module.exports = __webpack_public_path__ + "img/Balearic Islands.432973f2.svg";